import { lazyLoad } from 'utils/loadable';

export const ReportPageLoadable = lazyLoad(
  () => import('./PerformanceReportWrapper'),
  module => module.ReportPageWrapper,
);
